module.exports = __webpack_public_path__ + "static/media/bg.ce006086.webp";